import { Zap } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-zinc-800 bg-[#09090B]"
    >
      <div className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-10 lg:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center border border-blaze bg-blaze/10">
                <Zap className="h-4 w-4 text-blaze" fill="currentColor" />
              </span>
              <span className="font-display text-2xl tracking-tight">OVERCLOCK</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-zinc-500">
              Functional mushroom coffee for people who refuse to slow down. All
              the focus, none of the crash.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-14 gap-y-8 sm:grid-cols-3">
            <FootCol
              title="Product"
              links={["The Formula", "Reviews", "Subscribe & Save", "FAQ"]}
            />
            <FootCol
              title="Company"
              links={["Our Story", "Lab Results", "Wholesale", "Contact"]}
            />
            <FootCol
              title="Legal"
              links={["Shipping", "Returns", "Privacy", "Terms"]}
            />
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-zinc-800 pt-6 sm:flex-row sm:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            © 2026 Overclock Labs · All rights reserved
          </p>
          <p className="max-w-lg font-mono text-[9px] leading-relaxed tracking-[0.05em] text-zinc-700">
            These statements have not been evaluated by the FDA. This product is
            not intended to diagnose, treat, cure or prevent any disease.
          </p>
        </div>
      </div>
    </footer>
  );
};

const FootCol = ({ title, links }) => (
  <div>
    <div className="mb-4 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
      {title}
    </div>
    <ul className="space-y-2.5">
      {links.map((l) => (
        <li key={l}>
          <a
            href="#"
            className="text-sm text-zinc-400 transition-colors duration-200 hover:text-blaze"
          >
            {l}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
